import React from 'react'
import RacingBall from './RacingBall'
const Balls = ({ addStake }) => {

  function addBall(ball){
    addStake(ball)
    console.log(ball)
  }

    

  return (
    <div className='bg-[#fff] rounded-lg grid grid-cols-5 gap-10 p-4 '>
      {Array.from({ length: 10 }, (_, i) => (
        <RacingBall addBall={addBall} i={i} />
        ))}
      </div>
  )
}

export default Balls